import React, { FC, ReactNode, useEffect, useState } from 'react';
import Modal from '@common/modal';

import classnames from 'classnames/bind';
import styles from './testGuide.module.scss';
const cx = classnames.bind(styles);

interface IStepSlide {
  leftContent: ReactNode;
  rightContent: ReactNode;
}

const stepSlideList: IStepSlide[] = [
  {
    leftContent: (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          개발자 역검은
          <br />
          세 가지 유형으로 이루어져 있으며,
          <br />
          원하는 순서대로 응시할 수 있어요.
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step3')} />,
  },
  {
    leftContent: (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          중간 중간
          <br />
          쉬어갈 수도 있답니다.
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step4')} />,
  },
  {
    leftContent: (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          응시 도중에 중단하면,
          <br />
          나중에 이어서 응시할 수 있어요.
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step5')} />,
  },
  {
    leftContent: (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>나의 역량을 검사하러 출발~!</strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'pacc')} />,
  },
];

interface ITestGuideModalProps {
  visible: boolean;
  onClose: () => void;
  onApply: () => void;
}
const TestGuideModal: FC<ITestGuideModalProps> = ({ visible, onClose, onApply }) => {
  const [stepIndex, setStepIndex] = useState(0);
  const [isDisabledStartBtn, setIsDisabledStartBtn] = useState(false);

  const lastSlideIndex = stepSlideList.length - 1;

  const leftContentEl = stepSlideList[stepIndex].leftContent ?? <></>;
  const rightContentEl = stepSlideList[stepIndex].rightContent ?? <></>;

  const handlePrevStep = () => {
    if (stepIndex - 1 < 0) return;
    setStepIndex(stepIndex - 1);
  };

  const handleNextStep = () => {
    if (stepIndex + 1 > lastSlideIndex) return;
    setStepIndex(stepIndex + 1);
  };

  const onClickStartBtn = () => {
    setIsDisabledStartBtn(true);
    onApply();
  };

  useEffect(() => {
    if (visible) {
      setIsDisabledStartBtn(false);
      setStepIndex(0);
    }
  }, [visible]);

  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <div className={cx('infoArea')}>
          <div className={cx('infoInner')}>{leftContentEl}</div>

          <div className={cx('btnArea', `step${stepIndex + 1}`)}>
            {stepIndex > 0 && (
              <a className={cx('btnPrev')} role="button" onClick={handlePrevStep}>
                이전
              </a>
            )}
            {stepIndex === lastSlideIndex && (
              <button className={cx('btnNext')} onClick={onClickStartBtn} disabled={isDisabledStartBtn}>
                시작
              </button>
            )}
            {stepIndex !== lastSlideIndex && (
              <button className={cx('btnNext')} type="button" onClick={handleNextStep}>
                다음
              </button>
            )}
          </div>
        </div>
        {rightContentEl}

        <a className={cx('btnClose')} onClick={onClose} role="button">
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default TestGuideModal;
